module.exports = __webpack_public_path__ + "img/VB_logo_black.c4fe4cff.svg";